import { SignDetail } from 'src/app/model/sign/sign-detail';

export class SignWithStockAmount extends SignDetail {
  inProductionStock?: number;
  inOfferStock?: number;
  inDirectOrderStock?: number;

  // display variables
  displayExampleStyle?: any;
  amountStockClass?: string;
}
